import { BatchAddMemberFormRow } from '../types/batch-add-member-form-row';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { sinValidator } from '../../../../../validators/valid-sin.validator';
import { dateFormatValidator } from '../../../../../validators/date-format.validator';
import * as moment from 'moment';
import { dateNotInFutureValidator } from '../../../../../validators/date-not-in-future.validator';
import { MembersFileRecord } from '../interfaces/members-file-record';

export class BatchAddMembersFormFactory {
  private static formatDateForFormRow(dateString: string): string {
    if (!dateString) return '';

    const acceptedFormats = [
      'MMMM D, YYYY', // January 8, 1990
      'MMM D, YYYY', // Jan 8, 1990
      'DD-MM-YYYY', // 08-01-1990
      'DDMMYYYY' // 08011990
    ];
    return moment(dateString, acceptedFormats, true).format('DD/MM/YYYY').toString();
  }

  static initializeMemberFormRow(member?: MembersFileRecord): BatchAddMemberFormRow {
    const workFromHome = !!member ? member?.['WORK FROM HOME']?.toLowerCase() === 'y' : null;
    return new FormGroup({
      lastName: new FormControl<string>(member?.['LAST NAME'] ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      firstName: new FormControl<string>(member?.['FIRST NAME'] ?? '', {
        nonNullable: true,
        validators: [Validators.required]
      }),
      dateOfBirth: new FormControl<string>(this.formatDateForFormRow(member?.['DATE OF BIRTH'] ?? ''), {
        nonNullable: true,
        validators: [Validators.required, dateFormatValidator, dateNotInFutureValidator]
      }),
      socialInsuranceNumber: new FormControl<string>(member?.SIN?.toString() ?? '', {
        nonNullable: true,
        validators: [Validators.required, sinValidator]
      }),
      email: new FormControl<string>(member?.EMAIL ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.email]
      }),
      employmentStartDate: new FormControl<string>(this.formatDateForFormRow(member?.['EMPLOYMENT START'] ?? ''), {
        nonNullable: true,
        validators: [Validators.required, dateFormatValidator]
      }),
      employmentType: new FormControl<number | null>(member?.['EMPLOYMENT TYPE']?.id ?? null, {
        validators: [Validators.required]
      }),
      provinceOfEmployment: new FormControl<number | null>(member?.['PROVINCE OF EMPLOYMENT']?.id ?? null, {
        validators: [Validators.required]
      }),
      workFromHome: new FormControl<boolean | null>(workFromHome, {
        validators: [Validators.required]
      }),
      contributionStart: new FormControl<string>(this.formatDateForFormRow(member?.['CONTRIBUTION START'] ?? ''), {
        nonNullable: true,
        validators: [Validators.required]
      }),
      onLeave: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.required] }),
      leaveType: new FormControl<number | null>({ value: null, disabled: true }),
      leaveStartDate: new FormControl<string | null>({ value: null, disabled: true }),
      leaveExpectedReturnDate: new FormControl<string | null>({ value: null, disabled: true }),
      contributionsOnLeave: new FormControl<boolean | null>({ value: null, disabled: true })
    });
  }
}
